import { Stock } from "./Stock";
import { ApplicationException } from "./Card";
import { IScenarioState, ICampaign, IScenario, ChaosToken } from "./Scenario";
import { IAppState } from "./App";
import { LocalStorageUtil } from "./LocalStorageUtil";

export interface IGameSave {
    state: IAppState;
    name: string;
    date: string;
}
export class Game {
    static getCampaign(state: IScenarioState): ICampaign {
        if (!Stock.campaigns || !Stock.campaigns.length) throw new ApplicationException("No Campaigns are available");
        if (state.campaignIndex < 0 || state.campaignIndex >= Stock.campaigns.length)
            throw new ApplicationException(`Campaing index (${state.campaignIndex}) out of range`);
        return Stock.campaigns[state.campaignIndex];
    }
    static getScenario(state: IScenarioState): IScenario {
        const c = Game.getCampaign(state);
        if (!c.scenarios || !c.scenarios.length) throw new ApplicationException("No Scenarios are available for campaign " + c.name);
        if (state.scenarioIndex < 0 || state.scenarioIndex >= c.scenarios.length)
            throw new ApplicationException(`Scenario index (${state.scenarioIndex}) out of range`);
        const s = c.scenarios[state.scenarioIndex];
        return s;
    }
    static assembleChaosBag(tokenCount: number[]): ChaosToken[] {
        const a: ChaosToken[] = [];
        for (let i = 0; i < tokenCount.length; i++) {
            const c = tokenCount[i];
            if (c < 1) continue;
            for (let j = 0; j < c; j++) {
                a.push(i as ChaosToken);
            }
        }
        return a;
    }
    private static readonly saveName = "GameSaves";
    static listSaves(): IGameSave[] {
        return LocalStorageUtil.loadData<IGameSave[]>(Game.saveName, []);
    }
    static gameSaveDisplayName(s: IGameSave): string {
        const campaign = Game.getCampaign(s.state.scenarioState);
        const scenario = Game.getScenario(s.state.scenarioState);
        const noOfPlayers = s.state.numberOfPlayers;
        const players = `player${noOfPlayers === 1 ? "" : "s"}`;
        return `${s.date} - ${(campaign ? campaign.name + (scenario ? " - " + scenario.name : "") : "")} (${noOfPlayers} ${players})`;
    }
    static addSave(save: IGameSave) {
        const saves = this.listSaves();
        saves.push(save);
        LocalStorageUtil.saveData(Game.saveName, saves);
    }
    static replaceSave(save: IGameSave, index: number) {
        const saves = this.listSaves();
        saves.splice(index, 1, save);
        LocalStorageUtil.saveData(Game.saveName, saves);
    }
    static deleteSave(index: number) {
        const saves = this.listSaves();
        saves.splice(index, 1);
        LocalStorageUtil.saveData(Game.saveName, saves);
    }
}